import apiRoles from '@/api/roles'

const state = {
  data: [],
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getRolesStart: '[roles] Get roles start',
  getRolesSuccess: '[roles] Get roles success',
  getRolesFailure: '[roles] Get roles failure'
}

export const actionTypes = {
  getRoles: '[roles] Get roles'
}

const mutations = {
  [mutationTypes.getRolesStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getRolesSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getRolesFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.getRoles](context) {
    context.commit(mutationTypes.getRolesStart)
    return new Promise(resolve => {
      apiRoles
        .getRoles()
        .then(response => {
          context.commit(mutationTypes.getRolesSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getRolesFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
